// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AgeVerificationBanner-module-description-3px4o{margin-top:17px;margin-bottom:17px}.AgeVerificationBanner-module-description-3px4o.AgeVerificationBanner-module-successDescription-1Cwul{margin-top:0}.AgeVerificationBanner-module-warningLink-RgyUf{text-decoration:none;font-weight:var(--weight-medium);color:#3567ff}.AgeVerificationBanner-module-warningLink-RgyUf:hover{text-decoration:underline}", ""]);
// Exports
exports.locals = {
	"description": "AgeVerificationBanner-module-description-3px4o",
	"successDescription": "AgeVerificationBanner-module-successDescription-1Cwul",
	"warningLink": "AgeVerificationBanner-module-warningLink-RgyUf"
};
module.exports = exports;
